module.exports = __webpack_public_path__ + "static/img/zjfw_01.a671dda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zjfw_01.png
// module id = 7zmf
// module chunks = 1